import { render, staticRenderFns } from "./lockscreen.vue?vue&type=template&id=9b6bc52c&"
import script from "./lockscreen.vue?vue&type=script&lang=js&"
export * from "./lockscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports